import setupValidationAlerts from './validation-alerts';

// File Uploads
export default (form) => {
    const fileuploads = Array.from(form.querySelectorAll('.fileupload'));
    fileuploads.forEach((field) => {
        const input = field.querySelector('input');
        const label = field.querySelector('span');

        input.addEventListener('change', (e) => {
            label.innerHTML = e.target.files && e.target.files.length > 0
                ? `${e.target.files.length} files selected`
                : label.innerHTML = 'Choose a file...';
        });
    });

    // File Uploads -- acounts
    const fileuploaders = Array.from(form.querySelectorAll('.js-file-upload'));

    fileuploaders.forEach((field) => {
        let input = field.querySelector('input');
        const required = input.required;
        const emptyInput = input.cloneNode(true);
        emptyInput.required = required;
        const status = field.querySelector('.fileupload-outline__status');
        const size = field.querySelector('.fileupload-outline__size');
        const button = field.querySelector('.fileupload-outline__button');
        let fileAttached = false;

        const updateInterface = () => {
            const name = input.files[0].name;
            const bytes = input.files[0].size;
            status.innerHTML = name.length < 20 ? name : `${name.slice(0, 20)}...`;
            size.innerHTML = `${(bytes / 1000000).toFixed(2)}Mb`;
            button.innerHTML = 'remove';
        };

        const clearInterface = () => {
            status.innerHTML = '';
            size.innerHTML = '';
            button.innerHTML = 'upload';
        };

        const setupInputListeners = (element) => {
            element.addEventListener('change', () => {
                updateInterface();
                fileAttached = true;
            });
        };

        button.addEventListener('click', () => {
            if (!fileAttached) {
                input.click();
            } else {
                clearInterface();
                fileAttached = false;
                input.parentNode.replaceChild(emptyInput.cloneNode(true), input);
                input = field.querySelector('input');
                input.required = required;
                setupInputListeners(input);
                setupValidationAlerts(input);
            }
        });

        setupInputListeners(input);
    });
};
